export default __webpack_public_path__ + "static/media/erase.3ef1c6cb.svg";